<template>
    <div id="mysidebar" class="w-11/12">
        <div class="flex justify-center card-background">
            <vx-card class="xl:w-full lg:w-8/12 md:w-full shadow-lg custom-height px-4">
                <action-bar class="action-bar">
                    <template v-slot:left>
                        <vx-action-icon
                            :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                            @click="navBack"
                        >
                        </vx-action-icon>
                        <h2 class="ml-5">
                            {{
                                details.id
                                    ? 'Edit Content : ' +
                                      stateDescription(details.publishState) +
                                      ' ' +
                                      statusDescription(details.publishingStatus)
                                    : 'Create Content'
                            }}
                        </h2>
                    </template>
                </action-bar>
                <div class="flex justify-evenly mt-5">
                    <div class="w-6/12 px-2">
                        <vx-card>
                            <content-metadata v-model="details"></content-metadata>
                        </vx-card>
                    </div>
                    <div class="w-6/12 px-2">
                        <div class="w-full">
                            <vx-card>
                                <media-card
                                    :disableSave="disableMediaSave"
                                    :mediaPacket="tempContent"
                                    @mediaAdded="mediaAdded"
                                    @mediaEdited="mediaEdited"
                                ></media-card>
                            </vx-card>
                            <vx-card title="Sessions" class="my-4">
                                <added-media-table
                                    ref="added-media-table"
                                    :data="details.sessions"
                                    @removeMedia="removeMedia"
                                    @editMedia="editMedia"
                                />
                            </vx-card>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'
import { mapParams } from '@/plugins/mappers'
import AddedMediaTable from './AddedMediaTable'
import MediaCard from './MediaCard'
import ContentMetadata from './ContentMetadata.vue'
import publishMixins from '../mixins/publishMixins'

export default {
    name: 'player-details',
    components: {
        ActionBar,
        AddedMediaTable,
        MediaCard,
        ContentMetadata
    },
    mixins: [publishMixins],
    computed: {
        ...mapParams({
            playlistId: 'playlist_id'
        }),
        disableMediaSave() {
            return (
                !this.details.id ||
                (this.details.contentType == 1 && this.details.sessions.length == 1)
            )
        }
    },
    props: {},
    data() {
        return {
            details: {
                notes: [{ text: '' }],
                intendedAudiences: [],
                interests: [],
                restrictedToAudiences: [],
                name: null,
                description: null,
                contentType: 1,
                entitlement: null,
                experienceRequired: 50,
                genre: null,
                isLocked: false,
                sortOrder: null,
                tags: null,
                dateToPublishLive: new Date(),
                displayOnHomeScreen: false,
                sessions: []
            },
            tempContent: null
        }
    },
    methods: {
        navBack() {
            this.$router.go(-1)
        },
        async getDetails() {
            if (this.playlistId) {
                this.loading = true
                try {
                    this.details = await this.$api.playlist.fetchPlaylist(this.playlistId)

                    if (this.details.notes && !this.details.notes.any()) {
                        this.$set(this.details.notes, 0, { text: '' })
                    }
                } catch (err) {
                    console.error(err)
                    this.notifyError(
                        'Communication Error',
                        'Could not retrieve content details from server, please check your connection and try again.',
                        2000
                    )
                } finally {
                    this.loading = false
                }
            }
        },
        removeMedia(media) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Remove Media`,
                text: 'Are you sure you would like to remove this media?',
                accept: () => {
                    var index = this.details.sessions.findIndex(
                        (x) => x.contentId == media.contentId
                    )
                    this.details.sessions.splice(index, 1)

                    var data = {
                        playlistId: this.details.id,
                        contentId: media.contentId,
                        sortOrder: media.sortOrder
                    }

                    var response = this.$api.playlist.removeSession(data)
                    this.globalEmit('updated-player')
                }
            })
        },
        editMedia(line) {
            this.tempContent = line
        },
        mediaAdded(media) {
            this.details.sessions.push(media)
            var data = {
                playlistId: this.details.id,
                contentId: media.contentId,
                sortOrder: this.details.sessions.length
            }
            var response = this.$api.playlist.addSession(data)
            this.globalEmit('updated-player')
        },
        mediaEdited(media) {
            var index = this.details.sessions.findIndex((x) => x.contentId == media.contentId)
            this.details.sessions.splice(index, 1, media)
        }
    },
    watch: {
        playlistId: {
            handler: async function (playlistId) {
                if (playlistId) {
                    await this.getDetails()
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');

.card-background {
    background: transparent;
    height: 100%;
}
.custom-height {
    min-height: 540px;
}
.create {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
    letter-spacing: 2px;
}
a {
    font-size: 1rem;
}
p {
    color: #949c9c;
}
li {
    color: #949c9c;
    font-size: 1.1rem;
}
</style>
